import React from 'react';
import '../../../../css/common/chat/AdminSenderBadge.css';

const normalizeName = (value) => String(value || '').trim();

export const AdminSenderBadge = ({ className = '' }) => (
  <span
    className={['admin-sender-badge', className].filter(Boolean).join(' ')}
    data-tooltip="スタッフ"
    aria-label="スタッフ"
  >
    <span className="admin-sender-badge__mark" aria-hidden="true" />
  </span>
);

export const AdminSenderName = ({ name, className = '' }) => {
  const normalizedName = normalizeName(name);
  if (!normalizedName) return null;
  return (
    <span className={['admin-sender-name', className].filter(Boolean).join(' ')}>
      <span className="admin-sender-name__text">{normalizedName}</span>
    </span>
  );
};

export default AdminSenderName;
